module.exports = "th[sortable-column] {\n  cursor: pointer;\n}\n\nth:first-child, th:last-child {\n  background: none;\n}\n\n.no-cursor {\n  cursor: initial;\n}\n\n.content-container .table-responsive th div.inline-block {\n  display: inline-block;\n}\n\n.table-responsive {\n  height: calc(100vh - 320px);\n}\n\n.table-responsive table {\n  margin-bottom: 0;\n}\n\n.main-table tr {\n  vertical-align: middle;\n}\n\n.main-table td {\n  height: 54px;\n  vertical-align: middle;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/main-page/main-page.component.css
// module id = ./src/app/achelos-iot/main-page/main-page.component.css
// module chunks = main